<template>
  <div
    v-if="activeDialog"
    class="overlay"
    :class="activeDialog ? 'active': ''"
  >
    <div class="dialog-wrapper" :class="{'table-mode': showTable}">
      <div id="dialoge_close" class="close-dialog" @click="closePopups">
        <svg
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M12.0007 0.333008C5.54898 0.333008 0.333984 5.54801 0.333984 11.9997C0.333984 18.4513 5.54898 23.6663 12.0007 23.6663C18.4523 23.6663 23.6673 18.4513 23.6673 11.9997C23.6673 5.54801 18.4523 0.333008 12.0007 0.333008ZM17.834 16.188L16.189 17.833L12.0007 13.6447L7.81232 17.833L6.16732 16.188L10.3557 11.9997L6.16732 7.81134L7.81232 6.16634L12.0007 10.3547L16.189 6.16634L17.834 7.81134L13.6457 11.9997L17.834 16.188Z"
            fill="#D7DCE6"
          />
        </svg>
      </div>
      <h2>Add Contacts</h2>
      <div class="dialog-content-wrapper" :class="{'table-mode': showTable}">
        <div v-if="!showTable">
          <span>Select only SCV file format.</span>
          <span>
            The file should include 4 types of data in different columns: Contact group, Country code, Phone number,
            Contact email and Notes:
          </span>
          <img :src="csvExample" alt="csv-example">
          <div class="check">
            <CustomCheckbox
              :id="'personalized_message'"
              :input-element="isUserAcknowledged"
            />
            <span class="checkbox-text">
              I have explored the file requirements and ready to upload the relevant CSV file
            </span>
          </div>
          <div
            class="drop-area"
            :class="{ 'dragging': isDragging, 'disabled': !isUserAcknowledged.isActive }"
            @dragover.prevent="handleDragOver"
            @dragenter="handleDragEnter"
            @dragleave="handleDragLeave"
            @drop="handleDrop"
          >
            <svg
              width="34"
              height="34"
              viewBox="0 0 34 34"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <g opacity="0.5">
                <path
                  d="M17.2091 15.2377C17.1842 15.2059 17.1525 15.1802 17.1162 15.1626C17.08 15.1449 17.0402 15.1357 16.9999 15.1357C16.9596 15.1357 16.9198 15.1449 16.8836 15.1626C16.8473 15.1802 16.8156 15.2059 16.7907 15.2377L13.072 19.9425C13.0413 19.9817 13.0223 20.0287 13.0171 20.0781C13.0119 20.1276 13.0207 20.1775 13.0425 20.2222C13.0643 20.2669 13.0983 20.3045 13.1405 20.3308C13.1827 20.3571 13.2314 20.371 13.2812 20.3709H15.7349V28.4193C15.7349 28.5654 15.8544 28.6849 16.0005 28.6849H17.9927C18.1388 28.6849 18.2583 28.5654 18.2583 28.4193V20.3742H20.7187C20.9411 20.3742 21.064 20.1185 20.9278 19.9459L17.2091 15.2377Z"
                  fill="#373C44"
                />
                <path
                  d="M26.941 12.1727C25.4203 8.16172 21.5455 5.30957 17.0066 5.30957C12.4678 5.30957 8.59297 8.1584 7.07227 12.1693C4.22676 12.9164 2.125 15.5096 2.125 18.5908C2.125 22.2598 5.09668 25.2314 8.7623 25.2314H10.0938C10.2398 25.2314 10.3594 25.1119 10.3594 24.9658V22.9736C10.3594 22.8275 10.2398 22.708 10.0938 22.708H8.7623C7.64336 22.708 6.59082 22.2631 5.80723 21.4562C5.02695 20.6527 4.61191 19.5703 4.64844 18.448C4.67832 17.5715 4.97715 16.748 5.51836 16.0541C6.07285 15.3469 6.8498 14.8322 7.71309 14.6031L8.97148 14.2744L9.43301 13.0592C9.71855 12.3021 10.117 11.5949 10.6184 10.9541C11.1133 10.319 11.6996 9.76061 12.3582 9.29727C13.7229 8.3377 15.3299 7.82969 17.0066 7.82969C18.6834 7.82969 20.2904 8.3377 21.6551 9.29727C22.3158 9.76211 22.9002 10.3199 23.3949 10.9541C23.8963 11.5949 24.2947 12.3055 24.5803 13.0592L25.0385 14.2711L26.2936 14.6031C28.0932 15.0879 29.3516 16.7248 29.3516 18.5908C29.3516 19.6898 28.9232 20.7258 28.1463 21.5027C27.7653 21.886 27.312 22.1899 26.8127 22.3967C26.3135 22.6036 25.7781 22.7094 25.2377 22.708H23.9062C23.7602 22.708 23.6406 22.8275 23.6406 22.9736V24.9658C23.6406 25.1119 23.7602 25.2314 23.9062 25.2314H25.2377C28.9033 25.2314 31.875 22.2598 31.875 18.5908C31.875 15.5129 29.7799 12.923 26.941 12.1727Z"
                  fill="#373C44"
                />
              </g>
            </svg>
            <span>Drag and Drop here</span>
            <span>or</span>
            <button class="import-csv-btn">
              <input
                :id="`import_csv_btn`"
                ref="fileInput"
                type="file"
                accept=".csv"
                class="import-csv-input"
                :disabled="!isUserAcknowledged.isActive"
                @change="onFileChange"
              >
              <label :for="`import_csv_btn`" class="import-csv-label">
                <span>Select CSV file</span>
              </label>
            </button>
          </div>
        </div>

        <div v-if="showTable">
          <div class="table-header">
            <h3>Imported Contacts</h3>
          </div>
          <div class="table-container">
            <EditableTable
              :headers="tableHeaders"
              :data="tableData"
              :cell-errors="cellErrors"
              :cell-error-messages="cellErrorMessages"
              @update:data="tableData = $event"
              @cell-edited="validateTableData"
            />
          </div>
        </div>
      </div>
      <button
        v-if="showTable"
        id="dialoge_continue"
        :disabled="cellErrors.length > 0"
        class="btn dialog-btn"
        @click="uploadInscopeInfo"
      >
        <span class="dialog-btn-text">Continue</span>
      </button>
    </div>
    <AlertErrorMsg
      ref="alert"
      :title="errorMessage"
      class="page-alert-error"
    />
  </div>
</template>

<script>
import Papa from 'papaparse';
import CustomCheckbox from '@/components/inputs/CustomCheckbox.vue';
import EditableTable from '@/components/table/EditableTable.vue';
import csvExample from '@/assets/img/in-scope-contacts/csv-example.png';
import AlertErrorMsg from '@/components/profile/AlertErrorMsg.vue';

export default {
  name: 'AddInscopeContactsPopup',
  components: {
    AlertErrorMsg,
    CustomCheckbox,
    EditableTable,
  },
  emits: ['closed', 'uploadData'],
  data() {
    return {
      csvExample,
      activeDialog: false,
      isUserAcknowledged: {
        isActive: false,
      },
      isDragging: false,
      jsonData: null,
      tableHeaders: [
        {text: 'Contact group', width: 'auto'},
        {text: 'Country code', width: 'auto'},
        {text: 'Phone number', width: 'auto'},
        {text: 'Contact email', width: 'auto'},
        {text: 'Notes', width: 'auto'}
      ],
      tableData: [],
      showTable: false,
      errorMessage: '',
      cellErrors: [],
      cellErrorMessages: {},
    };
  },
  watch: {
    tableData: {
      handler(newValue) {
        if (newValue.length > 0 && this.jsonData) {
          // Create a map of group names to their indices in jsonData
          const groupIndices = {};
          this.jsonData.forEach((group, index) => {
            groupIndices[group.group_name] = index;
          });

          // Clear all contacts from existing groups
          this.jsonData.forEach(group => {
            group.contacts = [];
          });

          // Rebuild contacts from tableData
          newValue.forEach(row => {
            const groupName = row[0];
            const countryCode = row[1];
            const phone = row[2];
            const email = row[3];
            const note = row[4];

            // If the group doesn't exist yet, create it
            if (groupIndices[groupName] === undefined) {
              groupIndices[groupName] = this.jsonData.length;
              this.jsonData.push({
                group_name: groupName,
                contacts: []
              });
            }

            // Clean phone number by removing non-numeric characters
            let cleanedPhone = phone ? phone.trim() : '';
            // If phone number contains non-numeric characters, clean it
            if (cleanedPhone && !/^\d+$/.test(cleanedPhone)) {
              // Keep only digits
              cleanedPhone = cleanedPhone.replace(/\D/g, '');
            }

            // Add contact to the appropriate group
            this.jsonData[groupIndices[groupName]].contacts.push({
              phoneNumber: cleanedPhone,
              countryCode: cleanedPhone && countryCode
                ? (countryCode.trim().startsWith('+')
                  ? countryCode.trim()
                  : parseInt(countryCode.trim(), 10))
                : '',
              email: email ? email.trim() : '',
              note: note ? note.trim() : ''
            });
          });
        }
      },
      deep: true
    }
  },
  methods: {
    openPopups() {
      this.activeDialog = true;
    },
    closePopups() {
      this.activeDialog = false;
      this.showTable = false;
      this.tableData = [];
      this.errorMessage = '';
      this.cellErrors = [];
      this.cellErrorMessages = {};
      if (this.$refs.fileInput) {
        this.$refs.fileInput.value = '';
      }
      this.$emit('closed');
    },
    handleDragOver(event) {
      if (!this.isUserAcknowledged.isActive) return;
      event.preventDefault();
    },
    handleDragEnter(event) {
      if (!this.isUserAcknowledged.isActive) return;
      event.preventDefault();
      this.isDragging = true;
    },
    handleDragLeave(event) {
      if (!this.isUserAcknowledged.isActive) return;
      event.preventDefault();
      this.isDragging = false;
    },
    handleDrop(event) {
      if (!this.isUserAcknowledged.isActive) return;
      event.preventDefault();
      this.isDragging = false;
      const files = event.dataTransfer.files;
      if (files && files.length > 0) {
        this.processFile(files[0]);
        event.dataTransfer.clearData();
      }
    },
    processFile(file) {
      const dataTransfer = new DataTransfer();
      dataTransfer.items.add(file);
      this.$refs.fileInput.files = dataTransfer.files;
      this.onFileChange();
    },
    uploadInscopeInfo() {
      this.$emit('uploadData', this.jsonData);
      // Reset all data after the file was sent for uploading
      // this.showTable = false;
      // this.tableData = [];
      // this.errorMessage = '';
      // this.cellErrors = [];
      // this.cellErrorMessages = {};
      // this.jsonData = null;
      // this.isUserAcknowledged.isActive = false;
      // this.isDragging = false;
      // if (this.$refs.fileInput) {
      //   this.$refs.fileInput.value = '';
      // }
    },
    validateTableData() {
      this.cellErrors = [];
      this.cellErrorMessages = {};

      this.tableData.forEach((row, index) => {
        const phone = row[2] ? row[2].trim() : '';
        const email = row[3] ? row[3].trim() : '';
        const countryCodeStr = row[1] ? row[1].trim() : '';

        if (phone) {
          if (!/^\d+$/.test(phone)) {
            const errorMsg = 'Phone number contains invalid characters. Only digits are allowed.';
            this.cellErrors.push([index, 2]);
            this.cellErrorMessages[`${index}-2`] = errorMsg;
          }
          if (phone.startsWith('+')) {
            const errorMsg = 'Phone number should not include country code. Use the Country code field instead.';
            this.cellErrors.push([index, 2]);
            this.cellErrorMessages[`${index}-2`] = errorMsg;
          }
          if (!countryCodeStr) {
            const errorMsg = 'Country code is required when phone number is provided.';
            this.cellErrors.push([index, 1]);
            this.cellErrorMessages[`${index}-1`] = errorMsg;
          } else if (!/^\+\d+$/.test(countryCodeStr)) {
            const errorMsg = 'Country code must start with \'+\' followed by numeric values.';
            this.cellErrors.push([index, 1]);
            this.cellErrorMessages[`${index}-1`] = errorMsg;
          }
        }

        if (email) {
          if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) {
            const errorMsg = `Contact email "${email}" is invalid.`;
            this.cellErrors.push([index, 3]);
            this.cellErrorMessages[`${index}-3`] = errorMsg;
          }
        }
      });

      return this.cellErrors.length === 0;
    },
    onFileChange() {
      const fileInput = this.$refs.fileInput;
      if (!fileInput || !fileInput.files.length) {
        this.errorMessage = 'File not selected';
        this.$refs.alert.showAlert();
        return;
      }

      const file = fileInput.files[0];
      const expectedHeaders = [
        'Contact group',
        'Country code',
        'Phone number',
        'Contact email',
        'Notes'
      ];

      Papa.parse(file, {
        header: true,
        skipEmptyLines: true,
        complete: (results) => {
          const fileHeaders = results.meta.fields;
          if (fileHeaders.length !== expectedHeaders.length) {
            this.errorMessage = `Invalid number of headers. Expected ${expectedHeaders.length}, but found ${fileHeaders.length}.`;
            this.$refs.alert.showAlert();
            return;
          }

          for (let i = 0; i < expectedHeaders.length; i++) {
            if (fileHeaders[i] !== expectedHeaders[i]) {
              this.errorMessage = `Header should be "${expectedHeaders[i]}", but found "${fileHeaders[i]}".`;
              this.$refs.alert.showAlert();
              return;
            }
          }

          this.tableData = [];
          results.data.forEach(row => {
            let phoneNumber = row['Phone number'] ? row['Phone number'].trim() : '';
            if (phoneNumber && !/^[\d+]+$/.test(phoneNumber)) {
              phoneNumber = phoneNumber.replace(/[^\d+]/g, '');
            }

            this.tableData.push([
              row['Contact group'],
              row['Country code'],
              phoneNumber,
              row['Contact email'],
              row['Notes']
            ]);
          });

          this.validateTableData();

          const groupMap = {};
          results.data.forEach(row => {
            const groupName = row['Contact group'];
            if (!groupMap[groupName]) {
              groupMap[groupName] = {
                group_name: groupName,
                contacts: []
              };
            }
            let phone = row['Phone number'] ? row['Phone number'].trim() : '';
            const countryCodeStr = row['Country code'] ? row['Country code'].trim() : '';

            if (phone && !/^\d+$/.test(phone)) {
              phone = phone.replace(/\D/g, '');
            }

            groupMap[groupName].contacts.push({
              phoneNumber: phone,
              countryCode: phone ? (countryCodeStr.startsWith('+') ? countryCodeStr : parseInt(countryCodeStr, 10)) : '',
              email: row['Contact email'] ? row['Contact email'].trim() : '',
              note: row['Notes'] ? row['Notes'].trim() : ''
            });
          });

          this.jsonData = Object.values(groupMap);
          this.showTable = true;
        },
        error: (error) => {
          this.errorMessage = 'Error reading CSV file. ' + error.message;
          this.$refs.alert.showAlert();
        }
      });
    }
  }
};
</script>

<style scoped>
@keyframes show {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}

.overlay.active {
  animation: show .3s linear;
}

.dialog-wrapper {
  width: 100%;
  max-width: 600px;
  border: 1px solid #D7DCE6;
  box-sizing: border-box;
  border-radius: 30px;
  padding: 32px;
  background: #fff;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  position: relative;
}

.close-dialog {
  width: 70px;
  height: 70px;
  padding: 23px;
  position: absolute;
  top: 0;
  right: 0;
  cursor: pointer;
}

.close-dialog svg {
  width: 100%;
  height: 100%;
}

.close-dialog svg path {
  transition: .5s all;
}

.close-dialog:hover svg path {
  fill: var(--accent-color);
}

.close-dialog img {
  display: block;
  width: 100%;
}

h2 {
  font-weight: 700;
  font-size: 26px;
  line-height: 150%;
  color: var(--black-color);
  margin: 0 0 32px 0;
}

.dialog-content-wrapper {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 16px;
  padding: 32px;
  border: 1px dashed var(--light-gray);
  border-radius: 4px;
  margin-bottom: 32px;
}

.dialog-content-wrapper span {
  font-weight: 500;
  font-size: 14px;
  line-height: 100%;
  text-align: center;
  vertical-align: middle;
  color: var(--secondary-text-color);
}

.dialog-content-wrapper img {
  margin: 16px 0;
}

.check {
  display: flex;
  align-items: center;
  gap: 10px;
}

.check .checkbox-text {
  font-weight: 500;
  font-size: 14px;
  line-height: 120%;
  vertical-align: middle;
  text-align: left;
  color: var(--secondary-black-color);
}

.drop-area {
  padding: 20px;
  text-align: center;
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 16px;
  width: 100%;
}

.drop-area.dragging {
  border-color: #007bff;
  background-color: #f0f8ff;
}

.dialog-wrapper .dialog-btn {
  min-width: 140px;
  width: 100%;
  max-width: 140px;
  padding: 13px 12px;
  background-color: var(--white-color);
  border-color: var(--accent-color);
}

.dialog-wrapper .dialog-btn:hover {
  background-color: var(--accent-color);
  border-color: var(--accent-color);
}

.dialog-wrapper .dialog-btn:hover .dialog-btn-text {
  color: var(--white-color);
}

.dialog-btn-text {
  display: block;
  font-size: 16px;
  font-weight: 700;
  color: var(--accent-color);
  transition: .5s all;
  text-overflow: ellipsis;
  overflow: hidden;
  max-width: 100%;
  white-space: nowrap;
}

.import-csv-btn {
  background-color: var(--accent-color);
  border: 1px solid var(--accent-color);
  border-radius: 25px;
  max-width: 150px;
  width: 100%;
  height: 35px;
  color: var(--white-color);
  transition: 0.5s;
}

.import-csv-btn span {
  color: var(--white-color);
  font-weight: 500;
  font-size: 12px;
}

.import-csv-btn:hover {
  background-color: var(--accent-color);
  color: var(--white-color);
}

.import-csv-label {
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
}

.import-csv-input {
  display: none;
}

.drop-area.disabled {
  pointer-events: none;
  opacity: 0.5;
}

.table-container {
  width: 100%;
  border-top: 1px solid #E5E7EB;
  padding-top: 20px;
  max-height: 400px;
  overflow: auto;
  position: relative;
}

.table-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  position: sticky;
  top: 0;
  background-color: #fff;
  z-index: 2;
  padding-bottom: 10px;
  margin-bottom: 10px;
}

.table-container h3 {
  font-weight: 600;
  font-size: 18px;
  margin-bottom: 15px;
  color: var(--black-color);
  text-align: left;
}

.spoiler-toggle {
  cursor: pointer;
  color: #007bff;
  text-decoration: underline;
  font-size: 14px;
}

.error-container {
  width: 100%;
  background: #f8d7da;
  color: #721c24;
  border: 1px solid #f5c6cb;
  padding: 10px;
  margin-bottom: 15px;
  z-index: 3;
  white-space: normal;
  word-break: break-word;
  border-radius: 4px;
  position: sticky;
  top: 50px; /* Adjusted to account for the height of the table-header */
}

.error-container pre {
  white-space: pre-wrap;
  word-break: break-word;
  margin: 0;
  font-size: 14px;
}

.slide-down-enter-active,
.slide-down-leave-active {
  transition: transform 0.3s ease, opacity 0.3s ease;
}

.slide-down-enter,
.slide-down-leave-to {
  transform: translateY(-10px);
  opacity: 0;
}

.dialog-content-wrapper.table-mode {
  border: none;
  padding: 0;
  max-height: 500px;
}

.dialog-wrapper.table-mode {
  max-width: 900px;
  transition: max-width 0.3s ease;
}
</style>
